export default "__VITE_ASSET__DHZC6QmL__"